import { create } from "zustand";
import { orderByOptions as initialOrderByOptions } from "../utils/Offices";
import { Categories } from "../models/header";

export interface Translation {
  name: string;
  description: string;
}
export interface SystemRole {
  name: string;
  description: string;
}
interface DictionaryState {
  orderByOptions: { value: string; label: string }[];
  accountRole: Translation[];
  translationsType: Translation[];
  categoriesMenu: Categories[];
  systemRoles: SystemRole[];
  exchangeRate: number | null;
  setOrderByOptions: (options: { value: string; label: string }[]) => void;
  setAccountRole: (roles: Translation[]) => void;
  setTranslationsType: (translationsType: Translation[]) => void;
  setCategoriesMenu: (categories: Categories[]) => void;
  setSystemRoles: (roles: SystemRole[]) => void;
  setExchangeRate: (rate: number | null) => void;
}

export const useDictionaryStore = create<DictionaryState>((set) => ({
  orderByOptions: initialOrderByOptions,
  accountRole: [],
  translationsType: [],
  categoriesMenu: [],
  systemRoles: [],
  exchangeRate: null,
  setOrderByOptions: (options) =>
    set({ orderByOptions: Array.isArray(options) ? options : [] }),
  setAccountRole: (roles: Translation[]) =>
    set({ accountRole: Array.isArray(roles) ? roles : [] }),
  setTranslationsType: (translationsType: Translation[]) =>
    set({
      translationsType: Array.isArray(translationsType)
        ? translationsType
        : [],
    }),
  setCategoriesMenu: (categories) =>
    set({ categoriesMenu: Array.isArray(categories) ? categories : [] }),
  setSystemRoles: (roles: SystemRole[]) =>
    set({ systemRoles: Array.isArray(roles) ? roles : [] }),
  setExchangeRate: (rate: number | null) =>
    set({ exchangeRate: typeof rate === "number" ? rate : null }),
}));
